export const playbackRate = {
    SLOW: 0.6,
    NORMAL: 1,
    FAST: 1.7,
};
